export const SUPPORTED_AUDIO_EXTENSIONS: string[] = [
  "mp3",
  "ts",
  "mp4",
  "mov",
  "m4a",
  "flac",
  "wav",
  "wma",
  "aac",
  "aiff",
];
